// @ts-nocheck
class RecentlyViewed extends HTMLElement {
  constructor() {
    super();
    this.maxItems = parseInt(this.dataset.maxItems) || 20;
    this.container = null;
    this.slideshowComponent = null;
    this.isCustomCollection = document.querySelector('.custom-collection');
  }

  connectedCallback() {
    this.container = this.querySelector('slideshow-slides');
    this.slideshowComponent = this.querySelector('slideshow-component');
    
    if (!this.container) {
      console.error('RecentlyViewed: Slideshow container not found');
      return;
    }
    
    this.addCurrentToLocalStorage();
    this.renderRecentlyViewed();
  }

  get currentHandle() {
    const parts = window.location.pathname.split('/').filter(Boolean);
    return parts[0] === 'products' ? parts[1] : null;
  }

  getStoredHandles() {
    try {
      const data = JSON.parse(localStorage.getItem("recentlyViewed")) || [];
      return Array.isArray(data) ? data.filter(Boolean) : [];
    } catch (error) {
      console.warn('RecentlyViewed: Error parsing localStorage data:', error);
      return [];
    }
  }

  saveStoredHandles(data) {
    try {
      localStorage.setItem("recentlyViewed", JSON.stringify(data));
    } catch (error) {
      console.warn('RecentlyViewed: Error saving to localStorage:', error);
    }
  }

  addCurrentToLocalStorage() {
    const currentHandle = this.currentHandle;

    if (!currentHandle) return;

    const productTagHidden = document
      .querySelector('#product-information')
      ?.getAttribute('data-product-hidden');

    if (productTagHidden === 'true') return;

    let handles = this.getStoredHandles();
    handles = handles.filter(handle => handle !== currentHandle);

    handles.unshift(currentHandle);
    handles = [...new Set(handles)];
    handles = handles.slice(0, this.maxItems);

    this.saveStoredHandles(handles);
  }

  async fetchProductData(handle) {
    try {
      const url = `${window.location.origin}/products/${handle}?sections=product-cart-item`;
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP error ${response.status}`);

      const data = await response.json();
      if (!data["product-cart-item"]) {
        throw new Error('product-cart-item section missing');
      }

      return { handle, data: data["product-cart-item"] };
    } catch (error) {
      console.warn(`RecentlyViewed: Failed to fetch "${handle}"`, error);
      return null;
    }
  }

  createProductSlide(productData, index) {
    try {
      const parser = new DOMParser();
      const productDoc = parser.parseFromString(productData, 'text/html');
      const productForm = productDoc.querySelector('.product-cart-item');

      if (!productForm) {
        throw new Error('product-cart-item not found');
      }

      if (this.isCustomCollection) {
        productForm.querySelector('notify-button')?.remove();
      } else {
        productForm.querySelector('.product-sticker')?.remove();
      }

      const slideWrapper = document.createElement("slideshow-slide");
      slideWrapper.setAttribute('ref', 'slides[]');
      slideWrapper.setAttribute('aria-hidden', index > 0 ? 'true' : 'false');
      slideWrapper.setAttribute(
        'style',
        `--slideshow-timeline: --slide-${index + 1}; --product-media-fit: cover;`
      );
      slideWrapper.className = "resource-list__slide";
      slideWrapper.appendChild(productForm);

      return slideWrapper;
    } catch (error) {
      console.warn('RecentlyViewed: Slide creation failed', error);
      return null;
    }
  }

  updateSlideshowTimeline(slideCount) {
    if (!this.slideshowComponent || slideCount === 0) return;

    const timeline = Array.from(
      { length: slideCount },
      (_, i) => `--slide-${i + 1}`
    ).join(', ');

    this.slideshowComponent.style.setProperty('--slideshow-timeline', timeline);
  }

  updateNavigationButtons(slideCount) {
    const prevButton = this.querySelector('.slideshow-control--previous');
    const nextButton = this.querySelector('.slideshow-control--next');
    const arrows = this.querySelector('slideshow-arrows');

    const disable = slideCount <= 1;

    if (prevButton) prevButton.disabled = disable;
    if (nextButton) nextButton.disabled = disable;
    if (arrows) arrows.style.display = disable ? 'none' : '';
  }

  rebuildSlideshow() {
    if (!this.slideshowComponent) return;

    const parent = this.slideshowComponent.parentElement;
    if (!parent) return;

    const clone = this.slideshowComponent.cloneNode(true);

    this.slideshowComponent.remove();
    parent.appendChild(clone);

    this.slideshowComponent = clone;
  }

  async renderRecentlyViewed() {
    try {
      const currentHandle = this.currentHandle;

      const handles = [
        ...new Set(
          this.getStoredHandles()
            .filter(h => h !== currentHandle && h.trim() !== '')
        )
      ];

      if (!handles.length) {
        this.classList.add("hidden");
        return;
      }

      this.classList.remove('hidden');
      this.classList.add('block');

      const results = await Promise.all(
        handles.map(h => this.fetchProductData(h))
      );

      const validProducts = results.filter(Boolean);

      if (!validProducts.length) {
        this.classList.add("hidden");
        return;
      }

      this.container.innerHTML = '';

      const slides = validProducts
        .map(({ data }, i) => this.createProductSlide(data, i))
        .filter(Boolean);

      slides.forEach(slide => this.container.appendChild(slide));

      this.updateSlideshowTimeline(slides.length);
      this.updateNavigationButtons(slides.length);
      this.rebuildSlideshow();

    } catch (error) {
      console.error('RecentlyViewed: Render failed', error);
      this.classList.add("hidden");
    }
  }

  refresh() {
    this.renderRecentlyViewed();
  }

  clearRecentlyViewed() {
    try {
      localStorage.removeItem("recentlyViewed");
      this.container.innerHTML = '';
      this.classList.add("hidden");
      this.updateNavigationButtons(0);
    } catch (error) {
      console.warn('RecentlyViewed: Clear failed', error);
    }
  }

  disconnectedCallback() {}
}

if (!customElements.get("recently-viewed")) {
  customElements.define("recently-viewed", RecentlyViewed);
}
